import { styled } from 'stitches.config'

export const ImageContainer = styled('div', {
  position: 'relative',
  size: '100px',
})
